export const getApiHeaders = (contentType: 'json' | 'form-data' | 'none' = 'json'): HeadersInit => {
  const token = localStorage.getItem('token');
  
  const headers: HeadersInit = {
    'Authorization': `Bearer ${token}`,
  };

  if (contentType === 'json') {
    headers['Content-Type'] = 'application/json';
  }

  return headers;
};
